// 「吃瓜百科」分栏展示数据 —— 热榜 / 深读 / 冷知识 / FAQ

export const hotList = [
  { rank: 1, term: "塌房", note: "人设崩塌的通用说法", hot: 98, change: "up" },
  { rank: 2, term: "实锤", note: "坐实传闻的硬证据", hot: 95, change: "up" },
  { rank: 3, term: "破防", note: "心理防线被击穿", hot: 89, change: "new" },
  { rank: 4, term: "反转", note: "剧情 180 度大转弯", hot: 88, change: "up" },
  { rank: 5, term: "人设崩塌", note: "镜头形象被真实行为击碎", hot: 86, change: "flat" },
  { rank: 6, term: "撤热搜", note: "负面话题被公关下架", hot: 85, change: "down" },
  { rank: 7, term: "猹与闰土", note: "吃瓜场上的名场面比喻", hot: 83, change: "new" },
  { rank: 8, term: "控评", note: "组织化占领评论区", hot: 84, change: "up" },
];

export const featuredReads = [
  {
    id: "read-tafang",
    tag: "深读·塌房",
    title: "从「塌房」看人设经济：我们到底在追什么？",
    excerpt: "当偶像的人设一个接一个崩塌，我们或许该重新思考：公众人物与粉丝之间的信任，究竟建立在作品、人品还是精心运营的滤镜之上。",
    body: ["「塌房」之所以能戳中这么多人，是因为它精准踩中了偶像产业最核心的脆弱点——信任。粉丝购买的不只是作品，更是一种近乎信念的认同感；当偶像的真实面目与公开人设相悖，这种认同感就会在瞬间崩塌。","从传播学的角度看，人设的本质是一种「符号运营」。团队通过综艺、访谈、营业日常一点点强化某种人设，本质上是在为受众提供一种可预期、安全的「情感陪伴」。可人设越是完美，容错率就越低，一次真实的失误就可能引发连锁反应。","所以「塌房」并不只是八卦谈资，它也在提醒所有公众人物与内容创作者：经得起时间检验的，永远是真实的作品与人品，而不是精心雕琢的滤镜。对吃瓜群众而言，少一点神化，多一点平常心，或许才是追星与围观最健康的姿势。"],
    minutes: 8,
    image: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20small%20house%20collapsing%20into%20pieces%20beside%20a%20smartphone%2C%20symbolizing%20celebrity%20scandal%20and%20broken%20image%2C%20warm%20cream%20background%2C%20deep%20melon%20green%20and%20coral%20red%20palette%2C%20minimal%20clean%20vector%20art%2C%20high%20quality&width=1200&height=800&seq=chi-read-tafang&orientation=landscape",
  },
  {
    id: "read-shichui",
    tag: "深读·求证",
    title: "「实锤」的科学：一张截图离真相有多远？",
    excerpt: "从 P 图到断章取义，从录音剪辑到 AI 换脸，在信息验证越来越难的时代，我们该如何用「媒体素养」给吃瓜这件事装上刹车。",
    body: ["当一场舆论事件被层层转发，我们最需要的或许不是更多「瓜」，而是一套有效的核实方法。所谓「实锤」，应当经过信源、时间、逻辑三层检验：信息是否来自可靠信源？是否能与其他证据互相印证？叙述逻辑是否自洽？","截图可以修、录音可以剪、视频可能移花接木，甚至 AI 还能生成足以以假乱真的图像。在这个人人都有「发布权」的时代，辨别力本身就是一种稀缺能力，也是抵抗网络谣言最基础的防线。","教你几个实用动作：看到劲爆「实锤」先别急着转发，等一等官方通报；核对发布账号的历史可信度；交叉搜索多个信源。吃瓜的乐趣在于看懂，而看懂的前提，是先别急着被情绪牵着走。"],
    minutes: 10,
    image: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20magnifying%20glass%20over%20speech%20bubbles%20and%20a%20megaphone%2C%20symbolizing%20fact%20checking%20gossip%20news%2C%20warm%20cream%20background%2C%20deep%20melon%20green%20and%20coral%20red%20palette%2C%20minimal%20clean%20vector%20art%2C%20high%20quality&width=1200&height=800&seq=chi-read-shichui&orientation=landscape",
  },
  {
    id: "read-qianli",
    tag: "深读·历史",
    title: "从「猹与闰土」到「吃瓜群众」：一部围观史",
    excerpt: "鲁迅笔下月下持叉的闰土，为何成了今天的爆料人？从街角看客到手机屏前的猹，中国人围观热闹的方式走过了怎样的百年变迁。",
    body: ["围观，大概是中国人最古老也最普遍的「大众文化」之一。鲁迅笔下的看客，或袖手旁观、或津津有味，早已把围观者的群像描摹得入木三分。百年之后，围观从街角、茶馆搬进了手机屏幕，看客也从「群众」变成了「吃瓜群众」。","而「猹与闰土」的妙喻，正是一代网友对经典文学的一次轻松「再创作」：闰土成了放料人，瓜田成了信息场，蹲守的网友则成了那匹不小心就被叉中的猹。文学与网络在此交汇，也让古老的作品焕发出新的生命力。","与其说这是对经典的解构，不如说是当代人借助经典来理解自身处境：我们都是吃瓜的人，也都要学会在围观中不盲目跟风、不轻信谣言，做一个既看热闹、也看门道的现代「围观者」"],
    minutes: 12,
    image: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20moonlit%20watermelon%20field%20with%20a%20figure%20holding%20a%20pitchfork%20and%20a%20crowd%20of%20small%20observers%20peeking%20with%20smartphones%2C%20warm%20cream%20night%20background%2C%20deep%20melon%20green%20and%20coral%20red%20palette%2C%20minimal%20clean%20vector%20art%2C%20high%20quality&width=1200&height=800&seq=chi-read-qianli&orientation=landscape",
  },
  {
    id: "read-yaoyan",
    tag: "深读·法律",
    title: "吃瓜有风险：网络言论的边界在哪里？",
    excerpt: "一句转发、一次声讨，可能踩上造谣与侵权的红线。从名誉权到寻衅滋事，我们整理了围观与发声时需要留心的法律常识。",
    body: ["网络不是法外之地，吃瓜也要有边界意识。在围观和转发的过程中，以下几类行为需要特别留心：散布未经证实的谣言、对他人进行侮辱诽谤、泄露他人隐私，都可能触碰法律红线，轻则承担民事侵权责任，重则面临行政处罚甚至刑事责任。","对于普通网友而言，最需要警惕的是「随手转发即造谣」。在信息未经证实前，谨慎的表述、明确的来源，既是对自己负责，也是对当事人负责。一句玩笑的边界，可能就在法律条文之间。","本文仅作科普参考，具体个案请以法律规定与专业法律意见为准。理性吃瓜，从每一次「不轻信、不盲传」开始。"],
    minutes: 9,
    image: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20balance%20scale%20and%20shield%20next%20to%20a%20chat%20app%20interface%2C%20symbolizing%20online%20speech%20law%20and%20rumor%20risk%2C%20warm%20cream%20background%2C%20deep%20melon%20green%20and%20coral%20red%20palette%2C%20minimal%20clean%20vector%20art%2C%20high%20quality&width=1200&height=800&seq=chi-read-yaoyan&orientation=landscape",
  },
];

export const quickFacts = [
  {
    key: "fact-1",
    category: "冷知识",
    title: "「吃瓜」为什么是瓜，不是别的？",
    text: "「吃瓜」与北方话「吃瓜子儿」的发音有关——围观人群边嗑瓜子边看热闹的意象，慢慢演变成了「吃瓜」。而「瓜」作为消息的代称，则来自对不明消息的调侃，所谓「不明真相的吃瓜群众」与「吃瓜待熟」共同塑造了今天的用法。",
  },
  {
    key: "fact-2",
    category: "来源考",
    title: "「猹」到底是什么动物？",
    text: "鲁迅在《故乡》里写闰土用钢叉刺「猹」，现实中并没有叫猹的动物。据考证，这很可能是鲁迅对浙东一带方言的音译，指代獾类小兽。谁能想到，一个百年前的动物，如今成了吃瓜群众最贴切的自我写照。",
  },
  {
    key: "fact-3",
    category: "语言流变",
    title: "「控评」为何从宣传词变成了贬义词？",
    text: "「控评」最早只是描述粉丝管理评论区的中性说法，但随着组织化、机器化的刷屏泛滥，路人越来越反感被「捂嘴」。同一词语从专业术语到全网调侃，背后是公众对虚假舆论的反感与媒介素养的提升。",
  },
  {
    key: "fact-4",
    category: "行业黑话",
    title: "「水军」和「营销号」不是一回事",
    text: "水军指被雇佣批量发布评论、制造热度的账号，重「量」；营销号则是以生产流量内容为主的账号，重「引流」。一个负责造声势，一个负责造内容，两者经常协同出现，共同构成网络舆论的灰色产业链。",
  },
];

export const faqList = [
  {
    q: "「吃瓜百科」是什么类型的网站？",
    a: "「吃瓜百科」是一个以科普方式解读网络热点术语、流行梗、行业黑话与典故来源的内容站。我们用通俗、准确的语言，把热点事件里那些看不懂的词一个个拆开讲清楚，帮助大家在围观网络热点时不仅能看懂热闹，更能看明白门道。",
  },
  {
    q: "内容里的「瓜」和信息可信吗？",
    a: "我们的词条侧重解释「词的含义、来源与用法」，而非站队某一事件。涉及具体人物或事件的描述，均以官方通报与权威信源为准，并建议读者多方核实、让子弹飞一会儿，避免被断章取义或二手信息带偏。",
  },
  {
    q: "这些网络热词更新很快，多久会新增词条？",
    a: "热词的生命周期往往很短，我们会持续跟踪各平台的热点，及时收录新出现的梗与术语，并对热门词条进行补充修订。如果你有想了解却搜不到的词，也欢迎通过页脚的联系邮箱告诉我们。",
  },
  {
    q: "词条会讲解相关法律知识吗？",
    a: "会。许多吃瓜话题其实涉及名誉权、诽谤、隐私等法律常识，我们会在词条中以「温馨提示」的形式补充容易踩线的法律边界，帮助大家理性围观、谨慎发声。需要说明的是，相关内容仅作科普参考，不构成法律意见。",
  },
  {
    q: "网站内容可以转载或引用吗？",
    a: "我们鼓励知识的分享与传播。如需转载词条内容，请注明出处并保留原文链接，严禁用于商业用途的洗稿或二次演绎。涉及具体人物事件的表述请以官方信息为准。",
  },
];